import { useRouterState } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';

export default function NavigationProgress() {
  const isLoading = useRouterState({ select: s => s.status === 'pending' });
  const [width, setWidth] = useState(0);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (isLoading) {
      setVisible(true);
      setWidth(10);

      intervalRef.current = setInterval(() => {
        setWidth(w => {
          if (w >= 85) return w;
          // Slow down as it approaches 85%
          return w + (85 - w) * 0.08;
        });
      }, 100);
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
      setWidth(100);
      timerRef.current = setTimeout(() => {
        setVisible(false);
        setWidth(0);
      }, 300);
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isLoading]);

  if (!visible) return null;

  return (
    <div className='fixed top-0 left-0 right-0 z-[9999] h-0.5 pointer-events-none'>
      <div
        className='h-full bg-primary transition-[width] ease-out'
        style={{
          width: `${width}%`,
          transitionDuration: width === 100 ? '200ms' : '100ms',
        }}
      />
    </div>
  );
}
